<template>
  <div>
    <header>
      <Header />
    </header>
    <div id="main">
        <section class="report">

            <div class="reportTitle">
                <div class="inner4">
                    <h1>トークショーレポート</h1><p class="titleSub">Talk Show Reports</p>
                </div><!-- /inner4-->
            </div><!-- /reportTitle-->

            <section class="reportVhead reportVhead01">
                <div class="inner4">
                    <h1><img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/title.png" srcset="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/title@2x.png 2x" alt="公式写真集＆ムック本発売記念「美しい世界との出会い」" /></h1>
                </div><!-- /inner4-->
            </section><!-- /reportVhead-->

            <div class="reportBody">

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            2022年9月16日（金）～9月19日（月・祝）、東京・渋谷ヒカリエにて「東京カメラ部2022写真展」が開催されました。開催期間中のイベントステージでは、人気フォトグラファー、写真業界関係者、歴代東京カメラ部10選などをお招きして、さまざまなテーマでトークショーが行われました。
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            9月18日（日）に行われた北海道 美瑛町（NPO法人 美瑛町写真映像協会）のトークショーでは、美瑛町長 角和浩幸氏、株式会社拓真館 館長 前田景氏にご登壇いただき、「丘のまち風景写真の源流～美瑛町と前田真三」というテーマでお話しいただきました。
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/01.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 01" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->

				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            東京カメラ部運営 塚崎（司会）「皆さんこんにちは。本日はお集まりいただきありがとうございます。スペシャルゲストのおふたりをお招きして、『丘のまち風景写真の源流～美瑛町と前田真三』というテーマでお話ししたいと思います。まず、町長からご挨拶をお願いいたします」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/02.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 02" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            角和「皆さん、こんにちは。美瑛町で町長を務めております角和浩幸と申します。出身は神奈川県横浜市で、実家は今も東横線沿線にあります。ですから、（写真展会場のある）渋谷は懐かしい町ですが、30年以上実家を離れておりますので、この大きな変わりように驚きながらやって参りました」<br>
                            <br>
                            塚崎「続きましてオンラインでのご出演となります。前田さん、よろしくお願いいたします」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/03.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 03" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->

                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            前田「前田景と申します。よろしくお願いします。本日は美瑛の風景を撮り続けてきた、祖父であり写真家の前田真三のお話をさせていただこうと思い、参加させていただきました。僕も美瑛町に2年前に移住しました。それまでは最も渋谷が身近な町でしたので、今回はとてもうれしいです」<br>
                            <br>
                            塚崎「美瑛町は移住の方が増えていますね」<br>
                            <br>
                            角和「移住に力を入れていますし、もともと美瑛町で暮らしていらっしゃる方、そして移住されてきた方の両方と力を合わせて、より良い町作りをしていきたいと考えています」<br>
                            <br>
                            塚崎「前田真三先生の紹介をお願いいたします」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/04.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 04" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            前田「前田真三は1970〜90年代に活躍した風景写真の草分けと言いますか、ジャンルそのものを作ったような存在です。美瑛の丘を撮った写真が有名で、美瑛町が広く知られるきっかけを作った人間でもあります。僕の実の祖父にあたります。略歴ですが、生まれは東京都八王子ですが、40代で勤めていた商社を退職し、『丹渓』という会社を設立し、カメラマンとして活動していきます。その後、美瑛の風景に出会って、写真集も40冊以上出版しています。『前田真三ブーム』というようなものも起こり、風景写真の先駆けとして活躍しました。1987年にはギャラリー『拓真館』を美瑛に開設するなど、簡単に言ってしまえば、『風景写真の代表』というような存在ですね」<br>
                            <br>
                            塚崎「わたしも、日本の風景写真と言えば前田真三先生、と当たり前のように刷り込まれております。今日はオフィスにある写真集も持ってきましたが、そのくらい当たり前の存在ですので、風景写真に興味のある方は、ぜひ前田先生の写真集をご覧いただければと思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/05.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 05" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->

                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            前田「写真を何枚か見ていこうと思います。こちらは『麦秋鮮烈』という写真で、写真集の表紙にもなっています。1977年に撮影されたもので、美瑛の丘を代表する1枚ですし、祖父の代表作でもあります。いまでは目にすることができない景色。赤いところは『赤麦』という品種の麦なのですが、いまでは育てている農家さんはほぼおらず、赤麦を保存するような活動もされているくらいです」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/06.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 06" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->

                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            前田「続いては『麦秋多彩』という作品で、『麦秋鮮烈』とほぼ同じタイミングで撮られた写真です。小麦やジャガイモなどさまざまな作物が織りなすパッチワーク状の丘は、美瑛を代表する風景ですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/07.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 07" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            前田「こちらも雄大な写真ですね。シンプルな写真も魅力的です」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/08.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 08" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            前田「こちらは秋に撮られています。豆を収穫する農家さんが写っていますが、農家さんの営みも含めて美瑛の風景を収めているような写真もあります」<br>
                            <br>
                            塚崎「町長は農業もやられているんですよね」<br>
                            <br>
                            角和「美瑛町の風景に憧れ、足下の仕事として農業をするために移住しました。ですから、いまでも農業をしていますし、農業に対する思い入れはあります」<br>
                            <br>
                            塚崎「赤麦は作っていらっしゃいますか？」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/09.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 09" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            角和「作っておりません。種類がありまして、いま商品になるかというと、現在の需要には合わなくなってしまった品種です。別の種類の麦は作っていますし、赤く見える麦もまた増えてきていますので、新しい美瑛の丘の色が作られていくと思います」<br>
                            <br>
                            前田「美瑛町の風景は毎年違います。畑に植えられる作物は毎年変わるので、色の組み合わせが常に変化するという点も美瑛のおもしろいところでしょうね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/10.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 10" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            前田「奥の方に塔が見えます。塔をモチーフとした写真集も出したくらい、あらゆる角度から丘のアクセントになっています。これは『美馬牛（びばうし）小学校』の塔で、いまは僕の娘がこの小学校に通っています。まさか祖父も、ひ孫がここに通うとは思っていなかったでしょうね。不思議な縁です」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/11.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 11" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            前田「冬になると美瑛は一面真っ白になります。寒さなどは大変ですが、美しさには代えがたいものがあり、僕も大好きな風景です」<br>
                            <br>
                            塚崎「雪の青さがいいですね」<br>
                            <br>
                            前田「影が本当に美しいです。次も冬の写真なので見ていただきたいです」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/12.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 12" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            前田「これは曇の日で、地面も空も真っ白。その中に林がイモムシのように捉えられています。祖父はこの写真に対するコメントで、『美瑛町でこのような写真を撮るのが夢だった』というようなことを言っています。抽象的な写真の撮り方を目指していたのだと思います」<br>
                            <br>
                            塚崎「生誕100周年記念事業を行っていると伺いました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/13.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 13" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            前田「1922年生まれですので、2022年は記念の年です。美瑛町は知っているけれど、美瑛町で数多く撮られている写真の起源はどこにあるのかは知らないという方のために、改めて前田真三を知っていただきたいという気持ちがあり、生誕100周年記念事業を展開させていただいています」<br>
                            <br>
                            塚崎「美瑛町民が選んだ30枚というものがあると伺ったんですが」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/14.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 14" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            角和「お手元に配布した冊子がございますが、美瑛町民が選んだ30枚という、30人の町民が選んだ前田先生の作品を展示する写真展が開催されました。展示はもう終わってしまいましたが、冊子にその30枚が紹介されております。東京でお配りするのは今回が初めてと聞いていますので、ぜひお持ち帰りいただければと思います」<br>
                            <br>
                            前田「今回の30人の方の中には、前田真三をご存知だった方もいらっしゃいますし、名前は知らないけれど写真は見たことがある、というような方もいらっしゃいました。僕も取材に行かせてもらったのですが、いちばん驚いたのは、『この写真がきっかけで美瑛町に移住しました』とか、『写真家になりました』など、その人の人生を左右する力が1枚の写真にあるということ。もちろん祖父の写真の完成度の高さもあると思いますが、写真にそこまでの影響力があることに驚かされました」<br>
                            <br>
                            角和「美瑛町にとって、前田先生は本当に恩人のような存在でありまして、コロナ禍前は年間240万人の観光客にお越しいただいていました。それはすべて前田先生の写真が世界に広がっていくなかで、この風景はいったいどこにあるんだということで、美瑛にお越しいただけるようになったんです。美瑛町はこれまであまり観光に力は入れていなかった町なんですね。しかし前田先生に広めていただいたことで観光にも目を向けるようになり、北海道大学の観光学の先生とお話ししたこともありますが、『美瑛町は二度の宝くじにあたったようなものだよね』と言われました。一度目は前田先生が作品を発表してくださったこと、二度目は『青い池』が広まったこと。どちらも町としてなにかをしたわけではない、と言われれば本当にそう。前田先生に美瑛町の観光の基礎を作っていただきました」<br>
                            <br>
                            塚崎「人口1万人の町に240万人訪れるわけですからね。これは大変な規模だと思います。続きまして『美瑛町の被写体としての価値』というテーマに移ります」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/15.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 15" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            角和「美瑛町はさまざまな資源に恵まれております。丘があります。十勝岳という活火山もあります。四季折々、さまざまな美しい景観がありますけれども、やはり前田先生が撮影された丘の景色が、いまもこれからも美瑛を代表する景観になるんだろうと思います。そして、丘の景観ですが、人の農耕の営みが作っている風景だということが、僕は素晴らしいところだと思います」<br>
                            <br>
                            塚崎「自然風景という言葉もありますが、美瑛の丘は自然ではないんですよね。人が作っているんです。先ほど前田さんも触れていましたが、丘の色が違うのも意味があるんですよね？」<br>
                            <br>
                            角和「植えている作物の違いでこのような色が出ています。作物は毎年、同じ場所に同じものを植えると、『連作障害』といってうまく育たなくなるんです。去年が麦だったところが今年はジャガイモになる。そういうことを繰り返していきますので、この景色に出会えるのも一回きりかもしれず、それもまた美瑛の魅力かと思います」<br>
                            <br>
                            塚崎「つまり、来年はまた違う風景が撮れるということで、ですからリピーターが多いのでしょうね」<br>
                            <br>
                            角和「観光客の実態調査も行っていますが、10回以上訪れているという方も多いですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/16.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 16" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「続いて『前田真三と拓真館』というテーマに移ります」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/17.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 17" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            前田「拓真館は1987年に前田真三が廃校をリノベーションしてギャラリーに生まれ変わらせました。活動を通じて役場の方と話すようになり、廃校はどのように使うつもりかを祖父が聞いたところ、逆にアドバイスを求められ、写真ギャラリーをやってみようという流れからスタートしたそうです。祖父自身、人が来てくれるのか不安なスタートだったみたいですが、あれよあれよと人が集まり、最盛期には年間30万人以上の方が来てくださいました。美瑛町の観光の最初の一歩だったのかなと思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/18.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 18" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            前田「いまここでも生誕100周年の一環で展示をしておりますが、ほぼ全てが新しいプリントでの展示となっております。かなりの大きさのプリントですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/19.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 19" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            前田「プリントとともに、カメラやフィルムなど資料も展示しています。祖父が撮影をしていた時代ですから、当然撮影はフィルムで、作品はすべてポジフィルムが使われています。カメラは、6×6、4×5、8×10の3台を並べて撮っていたということです。35mmカメラではなく、中判や大判カメラを使って撮っていたということも特徴かもしれません。今回のプリントは、フィルムスキャンをしてデジタル出力して作られています。そのスキャンデータはとても美しいです。写真集やポジフィルムのダイレクトプリントなど貴重なものも見ることができます」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/20.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 20" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            前田「ポジフィルムで撮られる方はいま少ないと思いますが、ポジフィルムは見たままが記録されてます。プリントや写真集のような色が本当に出るのか、と思われることもありますが、そのままの色がフィルムに残されており、これを見て感動する方もいらっしゃいますね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/21.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 21" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            前田「拓真館の周囲の風景です。祖父はカメラマンでしたが、拓真館を作るときに運動場だったところに白樺を2,500本植えて小径を作ったんですね。祖父が存命のときは小さかったですが、いまでは立派な白樺の森になりました。風景写真を撮ることも仕事でしたが、風景を作る、空間を作ることも意識していたと思います」<br>
                            <br>
                            塚崎「この小径は、スマートフォン用アプリ『Locatone』の中の『カメラと旅する北海道・美瑛町』のスポットとしても登録されているので、場所がどこにあるか、どのような場所なのかも解説をアプリから調べられるようになっております」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/22.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 22" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            前田「こちらは、僕が撮影した写真です。白樺が樹氷のようになっています。1月、2月になると、このようにすべてが凍って真っ白になります」<br>
                            <br>
                            塚崎「続いては撮影マナーについて町長からご説明をお願いします」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/23.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 23" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            角和「ぜひ美瑛にお越しいただき、撮影を楽しんでいただきたいと心から思っていますが、一点だけお願いしたいのが、マナーを守っていただきたいということです。特に畑への出入りにつきましてはご遠慮いただきたいです。靴の裏にさまざまな細菌が付いています。他の土地を旅してきて、細菌が付いた靴で畑に入ってしまうと作物に影響が出ることがあります。撮影を心から楽しんでいただきたいという思いから官民一体となり、NPO法人にルールブックも作っていただきました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/24.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 24" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            角和「ひとつの例ですが、左が撮られた写真、右が撮影風景です。左側だけを見ると畑の中に入っているように見えますが、実は道路に三脚を立てているんです。こうした工夫で迫力ある写真が撮れますので、ご協力いただければありがたいです」<br>
                            <br>
                            塚崎「電線が入ってしまうとか、畑に立ち入りたくなるような場所もありますが、そういう場所は美瑛町では電線をセットバックしてくださったりしています」<br>
                            <br>
                            角和「道路から撮影すると、どうしても電線が入ってしまうというスポットがあったのですが、どうしようかというとき、電線を後ろに下げてしまえばいいのではないかと、実際に電線をセットバックして畑への侵入を防ぎました。そのようなことも取り組みとして行っています」<br>
                            <br>
                            塚崎「ルールブックというと厳しく感じられてしまうかもしれませんが、撮影を楽しむための環境整備にも尽力していますので、そこはご協力いただきたいということです」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/25.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 25" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            角和「こちらも実際の撮影例です。牧草が植わっていますが、初めてお越しいただいた方などの場合、牧草を見て作物だと気付かれない方もいると思います。基本的にすべての丘は畑なんです。何が植わっているかわからなくても、畑だと思っていただきたいです。例えばヒマワリが植わっていることもありますが、それは畑を遊ばせているのではなく、畑の土を育てるために植えているんですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/26.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 26" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            角和「宣伝がひとつございます。10月から、『びえい割』という、おひとり宿泊代3,000円の割引をさせていただきます。また、池が凍ってしまい青くならない11月から4月まで、青い池をライトアップするという企画を行います。冬ならではの体験ができるのもその季節の楽しさで、くどいほどお願いしている畑への立ち入りについても、『冬の体験メニュー』という企画を行いまして、許可が下りた場所に限り、雪に覆われた畑に入っていただくことができるようになります。板を切りサーフィンのようにしたもので雪の丘を滑るという、地元の農家さんが楽しんでいる遊びも楽しんでいただけます。さまざまな楽しみをご用意してお待ちしておりますので、冬の美瑛町にもお越しください」<br>
                            <br>
                            塚崎「『びえい割』は北海道外の方も対象だそうです。1泊につきひとり3,000円の割引になりますので、4人家族であれば12,000円の割引ということです。素敵なプランですね。これはどちらで受け付けているのですか？」<br>
                            <br>
                            角和「事前に観光協会にお問合せいただければ、対応させていただきます<br>
                            <br>
                            塚崎「青い池のライトアップは本当にすごいんです。普通にライトアップするだけでなく、ライトの色が変わるんですよね」<br>
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/27.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 27" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            角和「何色かのライトを当て続けるのではなく、ライティングの種類自体も変わりますので、さまざまな表情をお楽しみいただけると思います」<br>
                            <br>
                            塚崎「5分おきくらいに変わるんですよね。特にオススメしたいのが星空の日です。一見すると真っ暗になった感覚のライティングになるのですが、実は目ではわかりにくいくらいの弱い青色を池に当てているんですね。何を意図しているか、写真を撮る方ならピンときますよね。星空と青い池のライトアップを同時に撮れるようにしているんです。空と池の明るさを合わせることで、長秒露光で池に青色が出るようにしているんです。すごいですよね。完全に写真を撮る人のための設定ということです」<br>
                            <br>
                            角和「青い池は周囲に灯りが何もないところにあります。この灯りを絞るというのは、地元のカメラマンの方にアイデアをいただき、創り上げていきました」<br>
                            <br>
                            塚崎「雪が少し吹雪いているときに青い池ライトアップに行くのもオススメです。なぜかというと、ライトがこれまた考えられていまして、池だけを照らすのではなく空も照らしているんですね。ピンときますよね。通常写真を撮るときはフラッシュを炊かないと雪は写りませんが、このライティングだとフラッシュを炊かなくても雪が写るんです。写真を撮っている方にはビックリする設計となっています」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/28.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 28" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「町長、前田さんも今回ご参加されているということで、どうでしょう、前田真三先生の代表作『大地の詩』の写真集をプレゼントするというのはいかがでしょうか。それではジャンケンをしましょう。前田さん、お願いしてよろしいでしょうか」<br>
                            <br>
                            （数回のジャンケンで勝者決定、写真集贈呈）
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/29.jpg" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会） 29" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「最後に町長、ひと言お願いします」<br>
                            <br>
                            角和「美瑛町は写真とともに育ってきている町です。これからもさらに成長していく町だと思っていますので、ぜひ皆さまのお力をよろしくお願いします。本日はありがとうございました」<br>
                            <br>
                            前田「このような機会をいただきありがとうございました。美瑛町と前田真三というひとりの人間の出会いから、ここまでの広がりが生まれたというのは奇跡的なことだと思うので、今後も写真を活かしていきたいと思います。来年の1月まで写真展も開催しておりますので、お立ち寄りください」<br>
                            <br>
                            塚崎「本日はありがとうございました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

            </div><!-- /reportBody-->

        </section><!-- /report-->

    </div><!-- /main-->

    <Footer />
    <div class="actionMenu">
        <UpButton />
    </div>
  </div>
</template>
<script>
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    }
  },
  computed: {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.withRightLine {
  border-right: 1px solid #000;
}
.withLeftLine {
  border-left: 1px solid #000;
}
.report .reportVhead01{
    background-image: url("https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/titleBk.jpg");
    background-repeat: no-repeat;
    background-position: top center;
}
.natgeoLinkArea {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 100%;
}
.natgeoLinkArea div {
    width: 43%;
    margin-bottom: 24px;
}
@media screen and (max-width:640px){
    .natgeoLinkArea {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .natgeoLinkArea div {
        width: unset;
        margin: 24px 16px;
    }
}
</style>
